// oxlint-disable-next-line typescript/explicit-module-boundary-types
export function useAuthModal() {
  const state = useState('useAuthModal', () => shallowRef({ open: false }))

  return {
    open: toRef(() => state.value.open),
    set: (open: boolean): void => {
      state.value = { open }
    },
  }
}
